import { useEligibleForTwcg1935CodingAgentChoice } from '@/components/user-context/helpers/cohorts.ts';
import { experiments } from '@/utils/experiment/manifest.ts';
import { useExperiment } from '@/utils/experiment/use-experiment.ts';

import { useEligibleForGenericSampleData } from '../controllers';
import { WizardTemplateOption } from '../utils/types';

export type ExperimentKeys = keyof typeof experiments;

export const useIsGenericSampleData = (template: WizardTemplateOption) => {
	const { userEligibleForGenericSampleData } = useEligibleForGenericSampleData(template);

	return {
		genericSampleDataIsEnabled: userEligibleForGenericSampleData,
	};
};

export const useIsJfindOnboardIllustrationRefresh = () => {
	const config = useExperiment(experiments.jfindOnboardIllustrationRefresh);
	return config.type === 'enrolled' && config.value;
};

export const useIsCodingAgentChoice = () => {
	const codingAgentChoiceExperimentConfig = useExperiment(experiments.twcg1935CodingAgentChoice);

	const userEligibleForCodingAgentChoice = useEligibleForTwcg1935CodingAgentChoice();

	if (!userEligibleForCodingAgentChoice) {
		return {
			codingAgentChoiceIsEnrolledInTest: false,
		};
	}

	const codingAgentChoiceIsEnrolled = codingAgentChoiceExperimentConfig.type === 'enrolled';

	// Exposure is fired automatically by the SDK (manifest
	// `fireExperimentExposure: true`), so we don't return a manual fire.
	return {
		codingAgentChoiceIsEnrolledInTest:
			codingAgentChoiceIsEnrolled && codingAgentChoiceExperimentConfig.value,
	};
};
